import {
    CurrencyExchangeRounded as CurrencyExchangeIcon
} from '@mui/icons-material'

import {getSession} from '../../../hooks/useStorage/useStorage.jsx'

import {general as textsGeneral} from '../../../translate/Translate.jsx'

import './information.scss'

const Information = ({infoStore, onClick: handleClick}) => {
    const mode = getSession('mode')
    const table = getSession('table', '')
    const card = getSession('card', '')

    if (mode === 'desk') return <div/>

    const allowOrder = getSession('allowOrder')

    if (!allowOrder) return <div/>

    return <div className={'information'}>
        <div className={'div-information'} style={{
            borderColor: (infoStore.openStore) ? '#0dc143' : '#a11515'
        }}>
            {(!!table) && <div className={'left'} onClick={() => handleClick('table')}>
                <label className={'form-label-information'}>
                    {table}
                </label>
                <label>
                    {textsGeneral.table}
                </label>
            </div>}
            {(mode === 'card' && !!card) && <div className={'center'}>
                <label>
                    {card}
                </label>
                <label>
                    {textsGeneral.card}
                </label>
            </div>}
            <div className={'right'} onClick={() => handleClick('consultation')}>
                <CurrencyExchangeIcon className={'icon'}/>
                <label>
                    {textsGeneral.seeAccount}
                </label>
            </div>
        </div>
    </div>
}

export default Information
